import { create } from 'zustand'

export const useQuickLinksStore = create((set) => ({
  availableLinks: [],
  savedLinks: [],
  hydrated: false,
  setQuickLinksData: ({ availableLinks, userLinks }) =>
    set({
      availableLinks,
      savedLinks: userLinks,
      hydrated: true,
    }),
  setSavedLinks: (savedLinks) =>
    set((state) => ({
      ...state,
      savedLinks,
    })),
}))